module.exports = __webpack_public_path__ + "img/video-thumb-4-nl.03595519.png";